import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useActionChoices } from "stores";
import { actionInputName } from "components/action-modal/utils/inputName";
import { TASK_INPUT_NAMES } from "constants/action-form";
import { TASKS } from "constants/actions";
import { FormSelectInput } from "form";

const FertilizeOperationInput = ({
  helperText,
  isProposed,
  isViewMode,
  isDisabled,
}) => {
  const { t } = useTranslation();
  const { actions } = useActionChoices();

  const task = TASKS.fertilize;
  const taskInputName = TASK_INPUT_NAMES[task];

  const options = useMemo(() => {
    const operationOptions =
      actions.fertilize?.operations?.map(
        ({ operationTypeId, operationTypeName }) => {
          return {
            value: operationTypeId,
            label: operationTypeName,
          };
        },
      ) || [];
    const sorted = operationOptions.sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: "base" }),
    );
    return sorted;
  }, [actions]);

  return (
    <FormSelectInput
      name={actionInputName(taskInputName, "operationTypeId", isProposed)}
      placeholder={t("OperationInput.Fertilize.Placeholder")}
      helperText={helperText}
      shouldHaveErrorBehaviorAfterSubmit
      isDisabled={isDisabled}
      isViewMode={isViewMode}
      options={options}
    />
  );
};

export default FertilizeOperationInput;
